import { motion, MotionProps } from "framer-motion"

export function AgentSvg(
  props: Pick<React.SVGProps<SVGSVGElement>, "width" | "height" | "viewBox"> & MotionProps,
) {
  return (
    <motion.svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      variants={{
        rest: {
          y: 0,
          scaleX: 1,
        },
        hover: {
          scaleX: [1, 0.66, 1],
          y: [0, -10, 0],
          transition: {
            duration: 0.75,
            ease: [0.34, 1.56, 0.64, 1],
            repeat: Infinity,
            repeatDelay: 3,
          },
        },
      }}
    >
      <path
        d="M6.16923 1.42432L6.2138 1.26121L6.47381 0.810339C3.17796 1.49488 0 4.18372 0 7.25C0 10.8398 3.35786 13.75 7.5 13.75C11.6421 13.75 15 10.8398 15 7.25C15 4.15662 12.5067 1.56795 9.16676 0.911087L9.32678 1.52243C9.73515 1.61696 10.1273 1.74239 10.5 1.89534C11.4489 2.28469 12.272 2.85231 12.9172 3.54202C13.2606 3.90912 13.5536 4.3108 13.7884 4.73861C14.2106 5.50772 14.4444 6.36125 14.4444 7.25C14.4444 10.4442 11.4234 13.1835 7.5 13.1835C3.5766 13.1835 0.555556 10.4442 0.555556 7.25C0.555556 6.66363 0.685583 6.08686 0.920053 5.53634C1.09735 5.12006 1.33436 4.71879 1.62004 4.33975C2.66549 2.95257 4.36262 1.86301 6.16923 1.42432Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        d="M6.16923 1.42432C6.59835 1.35361 7.04305 1.31645 7.5 1.31645C7.92771 1.31645 8.92326 1.46027 9.32678 1.52243L9.16676 0.911087C9.16676 0.911087 8.88499 0.810312 7.5 0.75C7.15189 0.75 6.47381 0.810339 6.47381 0.810339L6.2138 1.26121C6.2138 1.26121 6.18078 1.3686 6.16923 1.42432Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        d="M2.85635 6.29672V6.37283C2.85635 7.4774 3.75178 8.37283 4.85635 8.37283H12.2534C13.2139 8.37283 14.0388 7.69001 14.2182 6.7464L14.3037 6.29671C13.5142 5.88148 3.25109 5.88149 2.85635 6.29672Z"
        fill="url(#paint0_linear_810_8)"
      />
      <motion.path
        d="M2.85635 6.29672V6.37283C2.85635 7.4774 3.75178 8.37283 4.85635 8.37283H12.2534C13.2139 8.37283 14.0388 7.69001 14.2182 6.7464L14.3037 6.29671C13.5142 5.88148 3.25109 5.88149 2.85635 6.29672Z"
        fill="#FFFFFF00"
        variants={{
          rest: {
            fill: "#FFFFFF00",
          },
          hover: {
            fill: ["#FFFFFF00", "#FFFFFF90", "#FFFFFF00", "#FFFFFF90", "#FFFFFF00"],
            transition: {
              delay: 0.75,
              duration: 0.75,
              repeat: Infinity,
              repeatDelay: 3,
              ease: [0.34, 1.56, 0.64, 1],
            },
          },
        }}
      />
      <path
        d="M0.52832 6.29672C0.52832 6.29672 2.26014 6.36689 2.85635 6.29672M14.3037 6.86764C13.9828 6.84206 14.6102 6.31885 14.3037 6.29671M2.85635 6.29672C3.25109 5.88149 13.5142 5.88148 14.3037 6.29671M2.85635 6.29672V6.37283C2.85635 7.4774 3.75178 8.37283 4.85635 8.37283H12.2534C13.2139 8.37283 14.0388 7.69001 14.2182 6.7464L14.3037 6.29671"
        stroke="var(--mui-palette-text-primary)"
        strokeWidth="0.5"
      />
      <motion.path
        d="M13.2645 3.51508L12.6793 5.12458C12.6657 5.1614 12.6411 5.19314 12.6088 5.21556C12.5766 5.23798 12.5383 5.25 12.499 5.25C12.4598 5.25 12.4215 5.23798 12.3892 5.21556C12.357 5.19314 12.3324 5.1614 12.3187 5.12458L11.7346 3.51508L10.1254 2.92985C10.0886 2.91619 10.0568 2.89158 10.0344 2.85935C10.012 2.82711 10 2.78879 10 2.74952C10 2.71025 10.012 2.67193 10.0344 2.63969C10.0568 2.60746 10.0886 2.58285 10.1254 2.56919L11.7346 1.98492L12.3197 0.375416C12.3334 0.338605 12.358 0.306856 12.3902 0.284437C12.4224 0.262017 12.4607 0.25 12.5 0.25C12.5393 0.25 12.5776 0.262017 12.6098 0.284437C12.642 0.306856 12.6666 0.338605 12.6803 0.375416L13.2654 1.98492L14.8746 2.57015C14.9114 2.58381 14.9432 2.60842 14.9656 2.64065C14.988 2.67289 15 2.71122 15 2.75048C15 2.78975 14.988 2.82807 14.9656 2.86031C14.9432 2.89254 14.9114 2.91715 14.8746 2.93081L13.2645 3.51508Z"
        fill="#F5CD19"
        stroke="var(--mui-palette-text-primary)"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        variants={{
          rest: {
            scale: 1,
          },
          hover: {
            scale: [0, 1],
            transition: {
              delay: 0.5,
              duration: 0.75,
              repeat: Infinity,
              ease: [0.34, 1.56, 0.64, 1],
              repeatDelay: 3,
            },
          },
        }}
      />
      <defs>
        <linearGradient
          id="paint0_linear_810_8"
          x1="8.38247"
          y1="5.98529"
          x2="8.38247"
          y2="8.78806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5EE38" />
          <stop offset="1" stopColor="#11EA0D" />
        </linearGradient>
      </defs>
    </motion.svg>
  )
}
